import React from 'react';
import clsx from 'clsx';
import Select from 'react-select';
import { withTranslation, WithTranslation } from 'react-i18next';
import SuperuserIsActive from '../../containers/SuperuserIsActive';

type ChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => void;

interface CustomerOption {
  label: string;
  value: number;
}

interface TargetTitleFieldsOwnProps {
  targetId: string;
  // Copies the id to the clipboard and briefly swaps the icon for a
  // confirmation message, by id — hence the fixed `target-id` below.
  onCopyId: (event: React.MouseEvent<HTMLElement>) => void;

  // Superuser-only customer reassignment. The list is fetched, so it is empty
  // until that resolves.
  customerName: string;
  customerId: number;
  customers: CustomerOption[];
  onChangeCustomer: (option: any) => void;

  name: string;
  onChangeName: ChangeHandler;
  subtitle: string;
  onChangeSubtitle: ChangeHandler;
  // Raw text; the container normalises it into a quoted array on change.
  tags: string;
  onChangeTags: ChangeHandler;

  styles: Record<string, string>;
}

// The editor's identity block: id, the superuser customer picker, and the three
// name-ish text fields.
const TargetTitleFields = ({
  targetId, onCopyId, customerName, customerId, customers, onChangeCustomer,
  name, onChangeName, subtitle, onChangeSubtitle, tags, onChangeTags, styles, t,
}: TargetTitleFieldsOwnProps & WithTranslation) => (
  <div className={clsx(styles['target--title-group'], 'pure-u-14-24')}>
    <div className={styles.id}>ID: {targetId + ' '}
      <i
        id="target-id"
        className="fa fa-clone"
        onClick={onCopyId}></i>
    </div>

    <SuperuserIsActive>
      <div style={{
        border: "1px solid red",
        padding: "0.5rem"
      }}>
        <h1>Superuser is active</h1>
        <div><label>{t('target.editor.label.customer')}</label></div>
        <Select
          placeholder="Select to change..."
          value={{ label: customerName, value: customerId }}
          options={customers}
          onChange={onChangeCustomer}
        />
      </div>
    </SuperuserIsActive>

    <div><label>{t('target.editor.label.title')}</label></div>
    <input type="text"
      value={name}
      onChange={onChangeName} />

    <div><label>{t('target.editor.label.subtitle')}</label></div>
    <input type="text"
      value={subtitle}
      onChange={onChangeSubtitle} />

    <div><label>{t('target.editor.label.tags')}</label></div>
    <input type="text"
      value={tags}
      onChange={onChangeTags}
      title="These tags can be used in dashboard. Use double quotation marks around tags and separate tags with commas."
    />
  </div>
);

export default withTranslation('common')(TargetTitleFields);
